import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationFacade, PurchaseService } from '@ridango/components';
import { Area } from '@ridango/components/lib/purchase/purchase.model';
import Env from '@ridango/core/env';
import { TicketDetailsZoneMapComponent } from '@ridango/widgets';
import { ModalController } from '@ionic/angular';
import { take } from 'rxjs/operators';

const currentStep = 'product-area';

@Component({
    selector: 'gl-purchase-v2-city-or-municipality-area',
    templateUrl: './city-or-municipality-area.component.html'
})
export class CityOrMunicipalityAreaComponent implements OnInit {
    @Output() nextStep: EventEmitter<void> = new EventEmitter<void>();
    @Input() productAreas: Area;
    currentLanguage = this.translate.currentLang;
    selectedAreaId: number;

    constructor(
        @Inject('ENV') public env: Env,
        private translate: TranslateService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private purchaseService: PurchaseService,
        private modalCtrl: ModalController,
        private applicationFacade: ApplicationFacade
    ) {}

    ngOnInit(): void {
        this.purchaseService.setPurchaseDataLoading(false);
    }

    async selectArea(areaId: number) {
        const urlSegments = this.activatedRoute.snapshot.url.map((segment) => segment.path);
        urlSegments.splice(urlSegments.indexOf(currentStep) + 1);

        if (this.selectedAreaId) {
            urlSegments.pop();
        }
        this.selectedAreaId = areaId;
        await this.router.navigate([this.translate.currentLang, 'purchase-v2', ...urlSegments, this.selectedAreaId]);
        this.nextStep.emit();
    }

    private resolveLocalizedMapSrc(assetsPath: string): string {
        const supportedLocales = ['sv', 'en'];
        const locale = supportedLocales.includes(this.translate.currentLang) ? this.translate.currentLang : 'en';
        return `${assetsPath}/img/purchase-flow-v2/product-area/areas-map-${locale}.png`;
    }

    async openZoneMap() {
        const assetsPath = await this.applicationFacade.assetsPath$.pipe(take(1)).toPromise();
        const modal = await this.modalCtrl.create({
            component: TicketDetailsZoneMapComponent,
            componentProps: { localizedMapSrc: this.resolveLocalizedMapSrc(assetsPath) },
            cssClass: 'ticket-details-zone-map-modal'
        });

        modal.addEventListener('ionModalDidPresent', () => {
            const content = document.querySelector('ion-content');
            if (content) {
                content.setAttribute('inert', '');
            }
        });

        modal.onDidDismiss().then(() => {
            const content = document.querySelector('ion-content');
            if (content) {
                content.removeAttribute('inert');
            }
        });

        await modal.present();
    }
}
